export const ROSTERED_LICENSE_INFO_HEADER_TEXT = 'Rostered License'
export const ROSTERED_LICENSE_INFO_BODY_TEXT =
  "This license is managed by your school's rostering system. To add users, cancel invitations, or remove users from this license, please contact your school district's rostering administrator"
